import { fetchWithAuth } from '@shared/utils/auth';
import { backendUrl } from '@shared/constants/urls/appUrls';

//------------------------------------------------------------------------------
//                              Поиск монет
//------------------------------------------------------------------------------
export async function getCoinList(coin){
  const url = `${backendUrl}/api/search/coins?q=${coin}`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка получения монет: HTTP error! Status: ${ response.status }`);
    }
    return await response.json();
  } catch (error) {
    console.error('Программная ошибка получния монет Error fetching get comments list:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx